import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {VisitorContactDto} from '../../../_services/configuration-services';

@Component({
    selector: 'app-customer-visitor-summary',
    templateUrl: './customer-visitor-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerVisitorSummaryComponent {

    @Input() isExploitant = false; // Depending on context (and not only the roles assigned to the user)

    @Input() visitor: VisitorContactDto | null = null;

}
